"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blitzReducer = blitzReducer;
var _types = require("./types");
var _types2 = require("../game/types");
var _types3 = require("../config/types");
var _coinsToCurrency = require("../../../utils/coinsToCurrency");
var _RoundState = require("../enums/RoundState");
var initialState = {
  locked: false,
  stopping: false,
  starting: false,
  on: false,
  playing: false,
  paused: false,
  totalWon: null,
  totalWonFeatures: 0,
  ringText: "START",
  lastCoinsWon: 0,
  roundsPlayed: 0,
  featuresWon: 0,
  roundNormalCoinsWon: 0,
  minRoundTime: 1,
  biggestWin: 0,
  roundsLeft: 0,
  rounds: 100,
  bRoundsPlayed: 0,
  flyingWins: false,
  roundState: _RoundState.RoundState.Ended
};
function blitzReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types3.SERVER_CONFIG:
      {
        if (action.payload.jurisdiction == "SGA") {
          return Object.assign({}, state, {
            minRoundTime: 600
          });
        }
        return state;
      }
    case _types.BLITZ_PLAY_START:
      {
        return Object.assign({}, state, {
          starting: true,
          playing: true,
          roundsLeft: action.payload,
          bRoundsPlayed: 0,
          rounds: action.payload,
          totalWon: state.totalWon > 0 ? state.totalWon : 0.00001 /// this is a hack, will appear as 0.00 but wont be showing, since 0 = false we cant set it to 0
        });
      }
    case _types.BLITZ_PLAY_START_RESPONDED:
      {
        return Object.assign({}, state, {
          starting: false
        });
      }
    case _types.BLITZ_PLAY_STOP_RESPONDED:
      {
        return Object.assign({}, state, {
          stopping: false
        });
      }
    case _types.BLITZ_PLAY_STOP:
      {
        return Object.assign({}, state, {
          playing: false,
          paused: false,
          stopping: true
        });
      }
    case _types.BLITZ_PLAY_PAUSE:
      {
        return Object.assign({}, state, {
          playing: false,
          paused: true
        });
      }
    case _types.BLITZ_PLAY_UNPAUSE:
      {
        return Object.assign({}, state, {
          playing: true,
          paused: false
        });
      }
    case _types.BLITZ_MODE_ON:
      {
        return Object.assign({}, state, {
          on: true,
          playing: false
        });
      }
    case _types.BLITZ_MODE_OFF:
      {
        return Object.assign({}, state, {
          on: false,
          playing: false,
          paused: false
        });
      }
    case _types.BLITZ_FLYINGWINS_ENABLE:
      {
        return Object.assign({}, state, {
          flyingWins: true
        });
      }
    case _types.BLITZ_FLYINGWINS_DISABLE:
      {
        return Object.assign({}, state, {
          flyingWins: false
        });
      }
    case _types.BLITZ_ROUND_STARTED:
      {
        return Object.assign({}, state, {
          roundsPlayed: state.roundsPlayed + 1,
          bRoundsPlayed: state.bRoundsPlayed + 1,
          roundsLeft: state.roundsLeft - 1,
          roundState: _RoundState.RoundState.Started,
          skipFeature: false
        });
      }
    case _types.BLITZ_ROUND_DEDUCT:
      {
        return Object.assign({}, state, {
          roundsPlayed: state.roundsPlayed - 1
        });
      }
    case _types.BLITZ_START_ROUND:
      {
        return Object.assign({}, state, {
          roundStarted: new Date(),
          roundNormalCoinsWon: 0
        });
      }
    case _types.BLITZ_FEATURE_COUNT:
      {
        return Object.assign({}, state, {
          featuresWon: state.featuresWon + 1
        });
      }
    case _types.BLITZ_FEATURE_WON:
      {
        return Object.assign({}, state, {
          totalWonFeatures: state.totalWonFeatures + action.payload.totalWon
        });
      }
    case _types.BLITZ_FEATURE_ADD_WIN:
      {
        return Object.assign({}, state, {
          totalWonFeatures: state.totalWonFeatures + action.payload.totalWon
        });
      }
    /** This due to a recent issue with blitz bonus rounds played regularly not being ended, not allowing for new blitz */
    // round void added to handle balance insufficient, or other error.
    case _types2.ROUND_VOID:
    case _types2.ROUND_END:
      {
        return Object.assign({}, state, {
          roundState: _RoundState.RoundState.Ended
        });
      }
    /** This covers rounds played outside of blitz, we want them to be included in stats. */
    case _types.BLITZ_STATS_UPDATE:
      {
        var newState = Object.assign({}, state, {
          totalWon: state.totalWon + action.payload.totalWon,
          lastCoinsWon: action.payload.totalCoinsWon,
          roundsPlayed: state.roundsPlayed + 1
        });
        if (action.payload.totalWon > state.biggestWin) {
          newState.biggestWin = action.payload.totalWon;
        }
        return newState;
      }
    case _types.BLITZ_ROUND_RESULT:
      {
        var _newState = Object.assign({}, state, {
          totalWon: state.totalWon + action.payload.totalWon,
          lastCoinsWon: action.payload.totalCoinsWon,
          roundState: _RoundState.RoundState.Ended
        });
        if (action.payload.totalWon > state.biggestWin) {
          _newState.biggestWin = action.payload.totalWon;
        }
        return _newState;
      }
    case _types.BLITZ_PAYLINE_WIN:
      {
        return Object.assign({}, state, {
          roundNormalCoinsWon: state.roundNormalCoinsWon + action.payload
        });
      }
    case _types.BLITZ_SET_ROUNDS:
      {
        return Object.assign({}, state, {
          rounds: action.payload
        });
      }
    case _types.BLITZ_RESET_COUNTERS:
      {
        _coinsToCurrency.coinsToCurrency;
        return Object.assign({}, state, {
          totalWon: 0,
          totalWonFeatures: 0,
          ringText: "START",
          lastCoinsWon: 0,
          roundsPlayed: 0,
          featuresWon: 0,
          roundNormalCoinsWon: 0,
          roundsLeft: 0,
          biggestWin: 0
        });
      }
    case _types.BLITZ_SHOW_SPLASH:
      {
        return Object.assign({}, state, {
          splashScreen: true
        });
      }
    case _types.BLITZ_CLOSE_SPLASH:
      {
        return Object.assign({}, state, {
          splashScreen: false
        });
      }
    case _types.BLITZ_FEATURE_SKIP:
      {
        return Object.assign({}, state, {
          skipFeature: true
        });
      }
    case _types.LOCK:
      {
        return Object.assign({}, state, {
          locked: true
        });
      }
    case _types.UN_LOCK:
      {
        return Object.assign({}, state, {
          locked: false
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map